
import faq from '~/assets/data/faq'
import PrismicData from '~/assets/js/prismic-controller.js'
export default {
  name: 'FAQProduct',
  nuxtI18n: {
    paths: {
      en: '/faq/:product',
      it: '/faq/:product',
      de: '/faq/:product'
    },
  },
  layout: 'faq',
  computed: {
    faqsBySection() {
      return this.faq.sort((a,b) => {
        return a.data.section.data.order - b.data.section.data.order
      }).reduce((rv, x) => {
        ;(rv[x.data.section.data.name] =
          rv[x.data.section.data.name] || []).push(x)
        return rv
      }, {})
    },
  },
  async asyncData({ $prismic, app, params, error, req, store }) {
    const lang = app.i18n.locales.filter((i) =>
      i.iso.includes(app.i18n.locale)
    )[0].iso
    try {
      const faq = await $prismic.api.query(
        $prismic.predicates.at('my.faq.product', params.product),
        { lang, pageSize: 100, fetchLinks: ['faq_section.name', 'faq_section.order'] }
      )
      return {
        faq: faq.results,
        documentLang: faq.results[0].lang.substr(0, 2)
      }
    } catch (e) {
      error({ message: JSON.stringify(e), statusCode: 404 })
    }
  },
  head() {
    const seo = faq.products.find(p => p.path === this.faq[0].data.product)
    return PrismicData.seo(this.$nuxtI18nHead({ addSeoAttributes: true }), 
      { seo_title: seo.seo_title[this.documentLang], seo_description: seo.seo_description[this.documentLang]},
      'faq/' + this.faq[0].data.product,
      this.documentLang,
      this.faq[0].data.product
    )
  },
}
